import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
const reasons = ['Instructeurs expérimentés et attentionnés', 'Programmes structurés par âge', 'Environnement positif et respectueux', 'Communauté forte et accueillante'];
export function WhySection() {
  return <section className="py-24 bg-neutral-50" data-id="element-151">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-152">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-153">
          <h2 className="text-3xl font-bold text-neutral-900 mb-4" data-id="element-154">
            Pourquoi choisir HLD Taekwondo?
          </h2>
          <div className="w-20 h-1 bg-red-600 mx-auto rounded-full" data-id="element-155"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-156">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-center p-6 bg-white rounded-xl shadow-sm border border-neutral-100" data-id="element-157">
              <CheckCircle2 className="w-6 h-6 text-red-600 mr-4 shrink-0" data-id="element-158" />
              <span className="text-lg font-medium text-neutral-800" data-id="element-159">
                {reason}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}